import { Camera, Id } from 'NSwag/ServerClient/Client.nswag';
import { Action } from 'redux';

export enum CameraActionTypes {
    AddCameras = 'ADD_CAMERAS',
    ModifyCameras = 'MODIFY_CAMERAS',
    DeleteCamera = 'DELETE_CAMERA'
}

export interface AddCameras extends Action {
    type: CameraActionTypes.AddCameras;
    cameras: Camera[];
}

export interface ModifyCameras extends Action {
    type: CameraActionTypes.ModifyCameras;
    cameras: Camera[];
}

export interface DeleteCameras extends Action {
    type: CameraActionTypes.DeleteCamera;
    ids: Id[];
}